"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mix = void 0;
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
function mix(color1, color2) {
    var _a = (0, colorManipulator_1.decomposeColor)(color1), values1 = _a.values, type1 = _a.type;
    var _b = (0, colorManipulator_1.decomposeColor)(color2), values2 = _b.values, type2 = _b.type;
    if (type1 !== type2) {
        throw Error('Cannot mix different color types. Please provide same color type, hex, rgb etc.');
    }
    var isHex = /^\#/.test(color1);
    var isHsl = /hsl/.test(type1);
    var newValues = values1;
    for (var i = 0; i < values1.length; i++) {
        var newValue = (values1[i] + values2[i]) / 2;
        newValues[i] = i === 3 ? newValue : Math.round(newValue);
    }
    var mixColor = (0, colorManipulator_1.recomposeColor)({
        type: type1,
        values: newValues,
    });
    return isHex ? (0, colorManipulator_1.rgbToHex)(isHsl ? (0, colorManipulator_1.hslToRgb)(mixColor) : mixColor) : mixColor;
}
exports.mix = mix;
